var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6.25C3 5.83579 3.33579 5.5 3.75 5.5H17.25C17.6642 5.5 18 5.83579 18 6.25C18 6.66421 17.6642 7 17.25 7H3.75C3.33579 7 3 6.66421 3 6.25ZM3.75 11C4.16421 11 4.5 11.3358 4.5 11.75V18.75C4.5 19.1642 4.16421 19.5 3.75 19.5C3.33579 19.5 3 19.1642 3 18.75V11.75C3 11.3358 3.33579 11 3.75 11ZM8 12.3125C8 11.8983 8.33579 11.5625 8.75 11.5625H20.25C20.6642 11.5625 21 11.8983 21 12.3125C21 12.7267 20.6642 13.0625 20.25 13.0625H8.75C8.33579 13.0625 8 12.7267 8 12.3125ZM8 18.25C8 17.8358 8.33579 17.5 8.75 17.5H20.25C20.6642 17.5 21 17.8358 21 18.25C21 18.6642 20.6642 19 20.25 19H8.75C8.33579 19 8 18.6642 8 18.25Z",
    fill: "#111111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.188dd86f.svg";
export { ForwardRef as ReactComponent };